var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((_vm.posts),function(post,index){return _c('div',{key:index,staticClass:"d-flex align-center flex-column"},[_c('BlogPost',{attrs:{"post":post}}),_c('v-spacer')],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }